import React from 'react';
import { stats } from '../data/mock';

const Stats = () => {
  return (
    <section className="bg-slate-900 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center group"
            >
              <div className="text-5xl sm:text-6xl font-bold text-white mb-2 group-hover:text-amber-400 transition-colors duration-300">
                {stat.value}
              </div>
              <div className="text-slate-400 font-medium uppercase tracking-wider text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
